import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import AuthService from "../../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import ContentLoader from "react-content-loader";

class RedirectionForgottenPassword extends Component {
  constructor() {
    super();
    this.Auth = new AuthService();
  }

  componentDidMount() {
    this.setState({});
  }

  render() {
    let content;
    content = (
      <CardBody>
        <img
          alt=""
          src={
            "/img/logo-password.png"
          }
          className="mcnImage"
          width="420"
          height="200"
          style={{ marginLeft: "auto", marginRight: "auto", display: "block" }}
        />
        <br />
        <p className="text-muted" align="center">
          Bravo, tu peux maintenant retourner te connecter avec ton nouveau mot
          de passe
        </p>
      </CardBody>
    );
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer />
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">{content}</Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default RedirectionForgottenPassword;



// WEBPACK FOOTER //
// ./src/views/Pages/RedirectionForgottenPassword/RedirectionForgottenPassword.js